import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "linkedin-post-attachment" }
const _hoisted_2 = { class: "linkedin-post-attachment__header" }
const _hoisted_3 = {
  key: 0,
  class: "linkedin-post-attachment__author"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "linkedin-post-attachment__author-info" }
const _hoisted_6 = { class: "linkedin-post-attachment__author-name" }
const _hoisted_7 = {
  key: 0,
  class: "linkedin-post-attachment__author-headline"
}
const _hoisted_8 = {
  key: 1,
  class: "linkedin-post-attachment__text"
}
const _hoisted_9 = ["href"]

import type { Attachment } from "@/dtos/Unipile.dto";
import { Icon } from "@iconify/vue";

interface Props {
  attachment: Attachment;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkedInPostAttachment',
  props: {
    attachment: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Icon), {
        icon: "mdi:linkedin",
        class: "linkedin-post-attachment__header-icon"
      }),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "linkedin-post-attachment__header-title" }, "LinkedIn post", -1))
    ]),
    (__props.attachment.author)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (__props.attachment.author.profile_picture_url)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: __props.attachment.author.profile_picture_url,
                class: "linkedin-post-attachment__avatar",
                alt: "Author"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(__props.attachment.author.name || "Unknown"), 1),
            (__props.attachment.author.headline)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.attachment.author.headline), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.attachment.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.attachment.text), 1))
      : _createCommentVNode("", true),
    (__props.attachment.share_url || __props.attachment.url)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          href: __props.attachment.share_url || __props.attachment.url,
          target: "_blank",
          class: "linkedin-post-attachment__link",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", null, "View on LinkedIn", -1)
        ]))], 8, _hoisted_9))
      : _createCommentVNode("", true)
  ]))
}
}

})